
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Label, FormGroup } from 'reactstrap'
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

class DateMultiSelect extends Component {
    render() {
        const { label, name, value, onChange, disabled, required,monthValue} = this.props
        console.log(this.props,"myprops")
        console.log(monthValue)
        return (
            <React.Fragment>
                 <FormGroup className='no-margin'>
                     <Label htmlFor="formrow-firstname-Input">{label} {required ? <span style={{ color: 'red' }}>*</span> : null}</Label>
                     <Flatpickr
                         className="form-control d-block"
                         placeholder="YYYY-MM-DD"
                         name={name}
                         disabled={disabled}
                         onChange={(dates) => {
                            const formattedDates = dates.map(date => date.format("YYYY-MM-DD"))
                            onChange({ target: { value: formattedDates } })
                        }}
                         options={{
                             altInput: true,
                             altFormat: "Y-m-d",
                             dateFormat: "Y-m-d",
                             mode: "multiple",
                             defaultDate: value
                         }}
                     />
                 </FormGroup>
             </React.Fragment>
        )
    }
}
//DateMultiSelect
DateMultiSelect.propTypes = {
    t: PropTypes.any,
    label: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    isInvalid: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    formatter:PropTypes.func,
    row:PropTypes.object,
    monthValue:PropTypes.object
}

export default DateMultiSelect
